import useSWR from 'swr';
import { AdminSettingsService } from '@/services/engine/admin-settings-service';
import type {
    ActivityPulseWindow,
    ActivityTrends,
} from '@/types/admin-settings';

const CACHE_KEY = 'admin-activity-trends';

export function useActivityTrends(windowDays: ActivityPulseWindow) {
    const { data, isLoading, error } = useSWR<ActivityTrends>(
        [CACHE_KEY, windowDays],
        () => AdminSettingsService.getActivityTrends(windowDays),
        { revalidateOnFocus: false },
    );

    return { trends: data, isLoading, error };
}
